import React from 'react';
import { Button } from 'baseui/button';
import { MIcon } from '../Icon';
import { IDummyProps } from './types';
import { overrides as customOverrides } from './overrides';
import { mergeOverrides } from 'baseui';
import { Overrides } from 'baseui/overrides';

export const View = React.forwardRef((props: IDummyProps, ref: any) => {
	const { ...newProps } = { ...props, kind: props.theme };
	const {
		shape = 'default',
		size = 'default',
		iconAfter = undefined,
		iconBefore = undefined,
		overrides,
		groupPosition,
		parentTheme,
		buttongroupShape,
		ellipsis,
		...rest
	} = props;

	const ariaChecked = props.isSelected
		? props.mode === 'radio' || props.mode === 'checkbox'
			? { 'aria-checked': 'true' }
			: {}
		: props.mode === 'radio' || props.mode === 'checkbox'
		? { 'aria-checked': 'false' }
		: {};

	const _iconSize =
		props.size == 'large' ? 'var(--epods--button-large-icon-size)' : 'var(--epods--button-default-icon-size)';

	return (
		<Button
			{...rest}
			startEnhancer={props.iconBefore ? <MIcon icon={props.iconBefore} size={_iconSize} /> : props.startEnhancer}
			endEnhancer={props.iconAfter ? <MIcon icon={props.iconAfter} size={_iconSize} /> : props.endEnhancer}
			overrides={
				overrides
					? mergeOverrides(
							customOverrides(
								props,
								newProps,
								!!props.children || !!props.text,
								ariaChecked,
							) as Overrides<any>,
							overrides as Overrides<any>,
					  )
					: (customOverrides(props, newProps, !!props.children || !!props.text, ariaChecked) as Overrides<
							any
					  >)
			}
			ref={ref}
		>
			{!props.hideLabel && props.children} {!props.hideLabel && props.text}
		</Button>
	);
});
